import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.2959 12.7959L9.7959 20.2959C9.58455 20.5072 9.29791 20.626 8.99902 20.626C8.70014 20.626 8.41349 20.5072 8.20215 20.2959C7.9908 20.0846 7.87207 19.7979 7.87207 19.499C7.87207 19.2001 7.9908 18.9135 8.20215 18.7021L14.9062 12L8.20402 5.2959C8.09937 5.19125 8.01636 5.06702 7.95973 4.93029C7.90309 4.79356 7.87394 4.64702 7.87394 4.49902C7.87394 4.35103 7.90309 4.20448 7.95973 4.06776C8.01636 3.93103 8.09937 3.80679 8.20402 3.70215C8.30867 3.5975 8.4329 3.51449 8.56963 3.45785C8.70636 3.40122 8.8529 3.37207 9.0009 3.37207C9.14889 3.37207 9.29543 3.40122 9.43216 3.45785C9.56889 3.51449 9.69312 3.5975 9.79777 3.70215L17.2978 11.2021C17.4025 11.3068 17.4856 11.4311 17.5422 11.5679C17.5988 11.7047 17.6279 11.8513 17.6277 11.9994C17.6275 12.1475 17.5981 12.2941 17.5412 12.4307C17.4843 12.5674 17.4009 12.6915 17.2959 12.7959Z",
      fill: "black"
    }, null, -1)
  ])))
}
export default { render: render }